module.exports = __webpack_public_path__ + "img/Step1@3x.6461abc2.jpg";